import todolist from "../Assets/todolist.png";
export const mainPortfolioData = [
  {
    name: "todolist",
    image: todolist,
    title:
      "Technologies: React, Node, Express, Typescript, Mongodb, Docker, Netlify, Render, CI/CD",
    text: "To do list with autentication.",
    buildUrl: "https://to-do-list-fast-mode.netlify.app/login",
    gitUrl: "https://github.com/Renanluizssx9/FrontEnd-To-do-List",
  },
];
